import React, { Component } from 'react';
import CounterCards from "../../components/common/countercards";
import { getOnlineAccounts, getAccounts, getCounters } from "../../services/accountService";
import { getTickets } from "../../services/ticketService";
import { getBandwidthUsage } from "../../services/bandwidthService";
import { toast } from "react-toastify";
import BandwidthChart from "../../components/common/bandwidthChart";
import SearchableSelect from '../../components/common/searchableSelect';
import PortalBillingStrip from "../../components/billing/PortalBillingStrip";
import "../../platform/workspace360/customer360.css";
import "./home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        interval: '5',
        intervalName: 'Daily',
        average: '5 Minute',
        username: "00-000000",
        staticip: "000.000.000.000",
      },      
      currentUser: "",
      currentPage: 1,
      pageSize: 10,
      searchQuery: "",
      sortColumn: { path: "id", order: "desc" },
      onlineAccounts: [],
      cards: [
        {
          path: "accounts",
          name: "Accounts",
          number: "",
          icon: <i className="fa fa-code-fork" />,
          background: "primary",
          linkto: "./accounts"
        },
        {
          path: "active",
          name: "Active",
          number: "",
          icon: <i className="fa fa-database" />,
          background: "success",
          linkto: "./accounts"
        },
        {
          path: "expired",
          name: "Expired",
          number: "",
          icon: <i className="fa fa-users" />,
          background: "danger",
          linkto: "./payments"

        },
        {
          path: "tickets",
          name: "Tickets",
          number: "",
          icon: <i className="fa fa-ticket" />,
          background: "info",
          linkto: "./tickets"
        },
      ],
      bandwidthUsage: [],
      accountList: [],
      intervalList: [
        { id: 1, label: 'Daily', value: '5', average: '5 Minute' },
        { id: 2, label: 'Weekly', value: '30', average: '30 Minute' },
        { id: 3, label: 'Monthly', value: '120', average: '2 Hour' },
        { id: 4, label: 'Yearly', value: '1440', average: '1 Day' },
      ],
    };
  }

  // Utility function for safe state updates
  safeSetState = (update) => {
    if (this._isMounted) {
      this.setState(update);
    }
  };

  _isMounted = false;
  intervalId = null;

  async populateCounters() {
    try {
      const response = await getCounters();
      if (!response || !response.data) {
        console.error('Client counters request did not return a response (possible 401 redirect or network error).');
        this.safeSetState({
          cards: this.state.cards.map(card => ({ ...card, number: 0 }))
        });
        return;
      }

      const counters = response.data;
      if (!Array.isArray(counters)) {
        console.error('Client counters response is not an array:', counters);
        this.safeSetState({
          cards: this.state.cards.map(card => ({ ...card, number: 0 }))
        });
        return;
      }

      const cards = this.state.cards.map(card => {
        const counter = counters.find(c => c.name === card.path);
        return { ...card, number: counter ? counter.number : 0 };
      });

      this.safeSetState({ cards });
    } catch (error) {
      toast.error('Error fetching counters');
      console.error('Error fetching counters:', error);
    }
  }

  async populateOnlineAccounts() {
    try {
      const { data: onlineAccounts } = await getOnlineAccounts();
      this.safeSetState({ onlineAccounts });
    } catch (error) {
      toast.error('Error fetching online accounts:', error);
    }
  }

  async populateAccountList() {
    try {
      const response = await getAccounts();
      const payload = response?.data;
      const accounts = Array.isArray(payload) ? payload : (payload?.data || []);

      if (!Array.isArray(accounts)) {
        console.error('Client accounts response is not an array:', payload);
        toast.error('Error fetching account list');
        return;
      }

      const accountList = accounts.map(account => ({
        id: account.id,
        label: account.username,
        value: account.staticip,
      }));

      if (accountList.length === 0) {
        this.safeSetState({ accountList });
        return;
      }

      const { value: staticip, label: username } = accountList[0];
      this.safeSetState({ accountList, data: { ...this.state.data, staticip, username } });

      await this.populateBandwidthUsage();
    } catch (error) {
      toast.error('Error fetching account list:', error);
    }
  }

  async populateBandwidthUsage() {
    try {
      const { username, intervalName } = this.state.data;
      const { interval } = this.state.data;
      const { data: rawBandwidthUsage } = await getBandwidthUsage(username, intervalName);
      const intervalInSeconds = interval * 60;
      const convertedBandwidthUsage = rawBandwidthUsage.map(data => ({
        timestamp: data.timestamp,
        uprate: data.upload / intervalInSeconds,
        downrate: data.download / intervalInSeconds,
      }));
      this.setState({ bandwidthUsage: convertedBandwidthUsage });
    } catch (error) {
      console.error('Error fetching bandwidth usage:', error);
    }
  }

  async componentDidMount() {
    this._isMounted = true;

    await this.populateCounters();
    await this.populateAccountList();
    await this.populateBandwidthUsage();

    this.setReloadInterval();
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.intervalId);
  }

  setReloadInterval() {
    const interval = this.state.data.interval * 60 * 1000;
    this.intervalId = setInterval(() => {
      if (this._isMounted) {
        this.populateBandwidthUsage();
      }
    }, interval);
  }

  handleUpdateDropDownButtonState = async (selected, name) => {
    console.log("name: " + name);
    console.log("selected: " + JSON.stringify(selected));
    clearInterval(this.intervalId);

    const data = { ...this.state.data };
    
    if (name === 'staticip') {
      const selectedAccount = this.state.accountList.find(account => 
        account.value === selected.currentTarget.value
      );
      if (selectedAccount) {
        data.staticip = selectedAccount.value;
        data.username = selectedAccount.label;
      }
    }
    
    if (name === 'interval') {
      const selectedInterval = this.state.intervalList.find(interval => 
        interval.value === selected.currentTarget.value
      );
      if (selectedInterval) {
        data.intervalName = selectedInterval.label;
        data.interval = selectedInterval.value;
      }
    }

    await this.safeSetState({ data });
    await this.populateBandwidthUsage();
    this.setReloadInterval();
  };

  render() {
    const { accountList, intervalList, data } = this.state;

    return (
      <React.Fragment>
        <CounterCards cards={this.state.cards} />
        <PortalBillingStrip />

        <div className="bandwidth-pane customer360-monitoring-card customer360-snapshot mb-4 mt-2">
          <div className="bandwidth-pane__header customer360-snapshot__header">
            <div className="customer360-snapshot__title-block flex-grow-1">
              <div className="customer360-snapshot__title-row">
                <span className="customer360-snapshot__icon" aria-hidden>
                  <i className="fa fa-area-chart" />
                </span>
                <h6 className="customer360-snapshot__title mb-0">
                  {data.intervalName} Average Bandwidth Usage for {data.username}
                </h6>
              </div>
            </div>
            <div className="bandwidth-pane__controls d-flex flex-shrink-0">
              <div className="bandwidth-pane__select">
                <SearchableSelect
                  name="username"
                  options={accountList}
                  value={data.staticip}
                  onChange={(selected) => this.handleUpdateDropDownButtonState(selected, 'staticip')}
                  error={null}
                  disabled={false}
                  showLabel={false}
                  style={{ width: '130px', marginRight: '8px' }}
                />
              </div>
              <div className="bandwidth-pane__select">
                <SearchableSelect
                  name="interval"
                  options={intervalList}
                  value={data.interval}
                  onChange={(selected) => this.handleUpdateDropDownButtonState(selected, 'interval')}
                  error={null}
                  disabled={false}
                  showLabel={false}
                  style={{ width: '115px', marginRight: '0px' }}
                />
              </div>
            </div>
          </div>
          <div className="bandwidth-pane__body">
            <BandwidthChart data={this.state.bandwidthUsage} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Home;
